<div class="dialog-container">
    <ng-container *ngIf="!loading; else loadingBlock">
        <div class="dialog-controls">
            <ng-container *ngIf="showUpload">
                <button (click)="showUpload = false" class="icon-button icon-big back">
                    <cds-icon shape="arrow" direction="left"></cds-icon>
                </button>
            </ng-container>
            <button (click)="closeDialog()" class="icon-button icon-big close">
                <cds-icon shape="window-close"></cds-icon>
            </button>
        </div>
        <ng-container *ngIf="!showUpload">
            <app-case-management
                (createNewDataset)="createNewDataset()"
                (openUnsubmittedDataset)="openUnsubmittedDataset($event)"
            ></app-case-management>
        </ng-container>
        <ng-container *ngIf="showUpload">
            <app-upload></app-upload>
        </ng-container>
    </ng-container>
    <ng-template #loadingBlock>
        <div class="default-loading-indicator loading-container">
            <cds-progress-circle></cds-progress-circle>
        </div>
    </ng-template>
</div>
